<template>
  <div>
    <!-- SIDEBAR -->
    <div class="sidebar" v-if="isAuth">
      <div class="brand">
        <a href="/">
          <img src="./assets/img/logo.png" alt="VDCI Logo" />
        </a>
      </div>
      <div class="sidebar-scroll">
        <nav>
          <ul class="nav">
            <li>
              <router-link :to="{ name: 'site-and-activity-map' }" exact
                ><i class="fa fa-home"></i
                ><span>Site &amp; Activity Map</span></router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'spray-paths' }" exact
                ><i class="fa fa-road"></i><span>Spray Paths</span></router-link
              >
            </li>
            <li v-if="isContract || isAdmin">
              <router-link :to="{ name: 'data' }" exact
                ><i class="fa fa-keyboard-o"></i><span>Data</span></router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'report' }"
                ><i class="fa fa-pie-chart"></i>
                <span>Reporting</span></router-link
              >
            </li>
            <li v-if="isAdmin">
              <router-link :to="{ name: 'lookup' }" exact
                ><i class="fa fa-table"></i>
                <span>Table Management</span></router-link
              >
            </li>
            <li v-if="isAdmin">
              <router-link :to="{ name: 'users' }" exact
                ><i class="fa fa-users"></i>
                <span>User Management</span></router-link
              >
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <!-- END SIDEBAR -->
    <!-- MAIN -->
    <div class="main">
      <!-- NAVBAR -->
      <nav class="navbar navbar-default" v-if="isAuth">
        <div class="flex-1"></div>
        <div id="navbar-menu" class="navbar-collapse collapse">
          <ul class="nav navbar-nav navbar-right">
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                <span>{{ user.firstName }} {{ user.lastName }}</span>
                <i class="icon-submenu lnr lnr-chevron-down"></i
              ></a>
              <ul class="dropdown-menu">
                <li>
                  <a href="#" v-on:click="onLogout"
                    ><i class="lnr lnr-exit"></i> <span>Logout</span></a
                  >
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
      <!-- END NAVBAR -->
      <!-- MAIN CONTENT -->
      <div class="main-content">
        <div class="container-fluid">
          <transition name="slide">
            <router-view></router-view>
          </transition>
        </div>
      </div>
      <!-- END MAIN CONTENT -->
    </div>
    <!-- END MAIN -->
  </div>
</template>

<script>
import AuthService from './services/AuthService';

export default {
  name: 'app',

  data() {
    return {};
  },

  computed: {
    isAuth() {
      return this.$store.state.isAuth;
    },
    user() {
      return this.$store.state.user;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isContract() {
      return this.$store.getters.isContract;
    },
  },

  methods: {
    onLogout() {
      AuthService.logout().then(() => {
        this.$router.push({ name: 'auth/login' });
      });
    },
  },

  mounted() {
    AuthService.getUser();
  },
};
</script>

<style lang="scss"></style>
